var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1645_19869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5C10.2427 4.5 11.25 5.50734 11.25 6.75C11.25 7.99266 10.2427 9 9 9C7.75734 9 6.75 7.99266 6.75 6.75C6.75 5.50734 7.75734 4.5 9 4.5ZM9 12C10.2427 12 11.25 13.0073 11.25 14.25C11.25 15.4927 10.2427 16.5 9 16.5C7.75734 16.5 6.75 15.4927 6.75 14.25C6.75 13.0073 7.75734 12 9 12ZM9 19.5C10.2427 19.5 11.25 20.5073 11.25 21.75C11.25 22.9927 10.2427 24 9 24C7.75734 24 6.75 22.9927 6.75 21.75C6.75 20.5073 7.75734 19.5 9 19.5ZM15 0C16.2427 0 17.25 1.00734 17.25 2.25C17.25 3.49266 16.2427 4.5 15 4.5C13.7573 4.5 12.75 3.49266 12.75 2.25C12.75 1.00734 13.7573 0 15 0ZM15 7.5C16.2427 7.5 17.25 8.50734 17.25 9.75C17.25 10.9927 16.2427 12 15 12C13.7573 12 12.75 10.9927 12.75 9.75C12.75 8.50734 13.7573 7.5 15 7.5ZM15 15C16.2427 15 17.25 16.0073 17.25 17.25C17.25 18.4927 16.2427 19.5 15 19.5C13.7573 19.5 12.75 18.4927 12.75 17.25C12.75 16.0073 13.7573 15 15 15Z",
    fill: "#D1D5DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1645_19869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedColor);
export default __webpack_public_path__ + "static/media/selectedColor.963b50ece3170369e3f63cb72165944d.svg";
export { ForwardRef as ReactComponent };